<script setup>
import {defineProps} from 'vue'

defineProps({
  loading: {
    type: Boolean,
    required: true,
  },
})
</script>

<template>
  <div class="position-wrapper" :class="{'is-loading': loading}">
    <div v-if="loading" class="blur-preloader">
      <i class="fa fa-circle-notch fa-spin fa-2xl blur-preloader-circle"></i>
    </div>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
.position-wrapper {
  display: contents;
}

.position-wrapper.is-loading {
  display: block;
  position: relative;
  overflow: hidden;
}
</style>
